import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'

import { UXFacet, UXFacetGroup } from '../../models/ux-facets'
import { FacetToggleEvent } from '../../models/facet-toggle-event';

@Component({
  selector: 'app-facetgroup',
  templateUrl: './template.html',
  styleUrls: ['./styles.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FacetgroupComponent {
  @Input() group: UXFacetGroup
  @Input() open: boolean
  @Input('applied') appliedFacets: string[]
  @Output() facetToggled = new EventEmitter<FacetToggleEvent>()
  @Output() groupToggled = new EventEmitter<string>()

  get name(): string {
    return this.group.name
  }

  get facets(): UXFacet[] {
    return this.group.facets
  }

  get groupIsShown(): boolean {
    // check if group has at least one applied facet
    if (this.appliedFacets && this.appliedFacets.length > 0) {
      return true
    } else {
      return !!(this.group.facets && this.group.facets.length > 1)
    }
  }

  toggled(event: FacetToggleEvent) {
    this.facetToggled.emit(event)
  }

  facetgroupToggled() {
    this.groupToggled.emit(this.group.code)
  }
}
